export const PROJECT_TODOS_CONFIG = {
    name            : 'Checklist',
    icon            : 'i5-todo-list',
    // image           : 'todo-list', // ???
    iconSvg         : 'isvg-todo-list',
    url             : 'todos',
    stringId        : 'todos',
    description     : 'On the Checklist page within the project, you can create and manage tasks and track their progress to ensure timely completion and smooth collaboration with the team.',
    menuName        : 'Checklist',
    inheritance     : false,
    // isSingleton     : true,
}
